export const DEVTOOLS_SET_PRESERVE_LOGS = 'DEVTOOLS_SET_PRESERVE_LOGS';
export const devtoolsSetPreserveLogs = (preserve) => ({ type: DEVTOOLS_SET_PRESERVE_LOGS, payload: preserve });

export const DEVTOOLS_ADD_LOG = 'DEVTOOLS_ADD_LOG';
export const devtoolsAddLog = (log) => ({ type: DEVTOOLS_ADD_LOG, payload: log });

export const DEVTOOLS_CLEAR_LOGS = 'DEVTOOLS_CLEAR_LOGS';
export const devtoolsClearLogs = () => ({ type: DEVTOOLS_CLEAR_LOGS });

export const DEVTOOLS_ADD_EXTENSION = 'DEVTOOLS_ADD_EXTENSION';
export const devtoolsAddExtension = (name, value) => ({ type: DEVTOOLS_ADD_EXTENSION, payload: { name, value } });
